import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofActionDispatched, State } from '@ngxs/store';
import { RouterAction } from './router.action';


@State({
    name: 'router',
})
@Injectable()
export class RouterState {
    constructor(private router: Router,
                private actions$: Actions,
    ) {
        this.actions$
            .pipe(ofActionDispatched(RouterAction.Navigate))
            .subscribe(({parts, extras}: RouterAction.Navigate) => {
                if (Array.isArray(parts)) {
                    this.router.navigate(parts, extras)
                } else {
                    this.router.navigateByUrl(parts, extras);
                }
            });
    }

}
